import { Switch as AntdSwitch, SwitchProps as AntdSwitchProps } from 'antd'

interface SwitchProps extends AntdSwitchProps {
  label?: string
}

export const Switch = (props: SwitchProps) => {
  const { label } = props

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div style={{ marginRight: 102 }}>{label && <span>{label}:</span>}</div>
      <div>
        <AntdSwitch {...props} />
      </div>
    </div>
  )
}

Switch.defaultProps = {
  style: {
    width: '100%',
    marginBottom: 20
  }
}
